import { getFunctions, httpsCallable } from "firebase/functions";
import toastHandler from "./toastHandler";
import {functions} from "../firebase";
import envUtils from "../utils/envUtils";
import { analytics } from "../firebase";
import { logEvent } from "@firebase/analytics";
import sentryUtils from "../utils/sentryUtils";

const timeEntry = {
  updateApproval: async (updatedData) => {
    let toastId = 'processingAprrovalsToast'
    toastHandler.loading("Processing...", toastId)
    
    let resData = httpsCallable(functions, "api/updateApproval");
    if (envUtils.isProfileMatchesWithValue("emulator") || envUtils.isProfileMatchesWithValue("test")) {
      resData = httpsCallable(getFunctions(), "mondaybaseurl/api/updateApproval");
    }
    resData(updatedData)
      .then((result) => {
        // Read result of the Cloud Function.
        const data = result.data;
        if(!data.error) {
          toastHandler.update(data, toastId, 'success')
          logEvent(analytics, 'update_approval', { "account_id": localStorage.getItem("accountId") });
        } else {
          const error = data.error;
          toastHandler.update(error, toastId, 'error')
          sentryUtils.captureAPIMessageException('updateApproval', error, "timesheetFunctions")
        }
      })
      .catch((error) => {
        toastHandler.update(error, toastId, 'error')
        sentryUtils.captureAPIException('updateApproval', error, "timesheetFunctions")
      });
  },
  updateApprovalBulk: async (updatedData) => {
  let toastId = "processingBulkApprovalsToast";
  toastHandler.loading("Processing bulk approval...", toastId);

  let resData = httpsCallable(functions, "api/updateApprovalBulk");

  if (
    envUtils.isProfileMatchesWithValue("emulator") ||
    envUtils.isProfileMatchesWithValue("test")
  ) {
    resData = httpsCallable(
      getFunctions(),
      "mondaybaseurl/api/updateApprovalBulk"
    );
  }

  return resData(updatedData)
    .then((result) => {
      const data = result.data;

      if (!data.error && data === "updated all documents") {
        toastHandler.update("Bulk approval completed successfully", toastId, "success");
        logEvent(analytics, "update_approval_bulk", {
          account_id: localStorage.getItem("accountId"),
        });
      } else {
        const error = data.error || data.msg;
        toastHandler.update(error, toastId, "error");
        sentryUtils.captureAPIMessageException(
          "updateApprovalBulk",
          error,
          "timesheetFunctions"
        );
      }
    })
    .catch((error) => {
      toastHandler.update(error, toastId, "error");
      sentryUtils.captureAPIException(
        "updateApprovalBulk",
        error,
        "timesheetFunctions"
      );
    });
},
};

export default timeEntry;